import { useState } from "react";
import BulkSipTableEditorModal from "./BulkSipTableEditorModal";

export default function BulkSipTableEditorAction({ items, onApplied, excludedComplexCount = 0, sourceSection = "admin", buttonStyle, buttonClassName, entityType = "sipClient", label = "Редактировать таблицу клиентов" }) {
  const [openedItems, setOpenedItems] = useState(null);
  const close = () => setOpenedItems(null);
  return <><button type="button" className={buttonClassName} style={buttonStyle} onClick={() => setOpenedItems(items)}>{label}</button><BulkSipTableEditorModal isOpen={Boolean(openedItems)} items={openedItems || []} entityType={entityType} excludedComplexCount={excludedComplexCount} sourceSection={sourceSection} onClose={close} onApplied={onApplied} /></>;
}
